import { BrowserRouter, Route,Routes } from 'react-router-dom';
import './App.css';
import HomePage from './HomePage/HomePage';
import ScanDetails from './ScanDetails/ScanDetails';
import { useState } from 'react';

function App() {
  const [email,setEmail]=useState('');
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(0);
  const [error, setError] = useState(null);

  const handleEmail=(email)=>{
    setEmail(email);
  }
  // useEffect(()=>{
  //   console.log(email);
  // },[email]);
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<HomePage handleEmail={handleEmail} setError={setError} setData={setData} setLoading={setLoading} loading={loading} error={error} />} />
        <Route path='/scan-details' element={<ScanDetails email={email} data={data} loading={loading} error={error} />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
